import { SYS_BUTTON_AUTH } from '@/store/mutation-types'

/**
 * 按钮权限统一存储（localStorage）
 *
 * 说明：
 * - sessionStorage 在关闭标签页后即清除，新开标签需重新拉权限，且与 token 等持久登录态不一致。
 * - 使用 localStorage 与登录态一致，跨标签页共享；登出时已执行 localStorage.clear()，会一并清除。
 */
const STORAGE = localStorage

/**
 * 获取按钮权限列表（原始数组，项含 path / resourceUri 等）
 * @returns {Array}
 */
export function getButtonAuth() {
  try {
    const raw = STORAGE.getItem(SYS_BUTTON_AUTH)
    const list = raw ? JSON.parse(raw) : []
    return Array.isArray(list) ? list : []
  } catch (e) {
    return []
  }
}

/**
 * 写入按钮权限列表（登出或拉取权限后调用）
 * @param {Array} list
 */
export function setButtonAuth(list) {
  try {
    const arr = Array.isArray(list) ? list : []
    STORAGE.setItem(SYS_BUTTON_AUTH, JSON.stringify(arr))
  } catch (e) {
    // ignore
  }
}
